import PropTypes from "prop-types";
import { useContext } from "react";
import { Box, Grid } from "@mui/material";
import { CartsContext } from "./_CartsContext";
import { BudgetBox } from "..";

CartBudget.propTypes = {
  cart: PropTypes.object,
  facilityId: PropTypes.string
};

export default function CartBudget({ cart, facilityId }) {
  const { totals } = useContext(CartsContext);
  const items = totals[cart.categoryId]?.items ?? [];

  return <Grid item xs={3} sx={{ mt: 7 }}>
    {[...new Set(items.map(item => item.categoryId))].map(categoryId => (
      <Box key={categoryId} sx={{ my: 1 }}>
        <BudgetBox
          catId={categoryId}
          cart={items.filter(item => item.categoryId === categoryId)}
          facId={facilityId}
        />
      </Box>
    ))}
  </Grid>;
}
